import { OverviewItems } from 'components/cases/common/Overview/Overview'
import { IssueSolutionItems } from 'components/cases/common/Overview/Overview'
import { CaseStudyItems } from 'components/cases/common/CaseStudy/CaseStudy'

// ファーストビュー
export const firstViewItem = {
  breadcrumb: 'QUICK Global Alert',
  title1: 'QUICK Global Alert',
  introduction_text:
    '金融マーケット関係者に、世界の情報を素早くご提供するアプリを開発いたしました。このアプリは、金融関係のお客様に要求されるクラウド上での高いセキュリティレベルの実現と、Xamarinを利用した1ソースでマルチデバイス対応をしています。弊社はこのアプリ開発を実施しました。',
  company: '株式会社QUICK',
  tag1text: 'アプリケーション開発',
  tag1src: '/cases/application-development',
  tag2text: 'UI/UXデザイン',
  tag2src: '/cases/uiuxdesign',
  industryTagText: 'IT/情報/通信',
  industryTagSrc: '/cases/telecommunications',
  color: '#fff',
  background: '#003B75',
  staff1: '',
  image: '/images/img/cases/caseStudyTop/quick.webp',
  alt: 'QUICK Global Alert',
  imgClass: 'fv_img_adjust1',
}

// プロジェクト概要
export const overviewTitle = 'クラウドネイティブで高いセキュリティレベルを実現'
export const overviewItem: OverviewItems[] = [
  {
    text: '金融関係のお客様に要求されるクラウド上での高いセキュリティレベルの実現と、Xamarinを利用した1ソースでマルチデバイス対応のアプリ開発を担当させていただきました。',
  },
]

// 課題と解決策
export const issueSolutionItems: IssueSolutionItems[] = [
  {
    issues: [
      {
        title: 'デザインの知識がなく、直感的に操作できるアプリの開発が難しい',
        text: '',
      },
      {
        title: 'サーバーサイドの知識はあるが、フロント側のアプリ開発の知見がない',
        text: '',
      },
      {
        title: 'クラウド上で高いセキュリティレベルを担保したアプリを作りたい',
        text: '',
      },
    ],
    solutions: [
      {
        title: '初見のユーザーが直感的に操作できるUIの作成',
        text: '',
      },
      {
        title: '複数のプロジェクトで得た、フロント開発の知見を活用',
        text: '',
      },
      {
        title: 'クラウドの知見が深い専門メンバーをアサインし実装',
        text: '',
      },
    ],
  },
]

// 関連事例
export const caseStudyItem: CaseStudyItems = [
  {
    projectName: '【技術系災害ボランティア体験】家屋再生〜水害編〜',
    client: '公益財団法人日本財団ボランティアセンター様',
    src: '/images/img/case/img_case_volunteer-ex.png',
    alt: '公益財団法人日本財団ボランティアセンター様',
    href: '#',
    tags: [{ name: 'XR/メタバース導入', url: 'xr' }],
  },
  {
    projectName: 'PEACH JOHN',
    client: '株式会社ピーチ・ジョン様',
    src: '/images/img/case/img_peachjohn.png',
    alt: '株式会社ピーチ・ジョン様',
    href: '#',
    tags: [
      { name: 'UI/UXデザイン', url: 'uiux' },
      { name: 'アプリケーション開発', url: 'application-development' },
      { name: '小売', url: 'service' },
    ],
  },
  {
    projectName: 'セブンネットショッピング「推し活倶楽部」',
    client: '株式会社セブンネットショッピング様',
    src: '/images/img/case/img_sevennet.png',
    alt: '株式会社セブンネットショッピング様',
    href: '#',
    tags: [
      { name: 'UI/UXデザイン', url: 'uiux' },
      { name: 'アーキテクチャ設計サービス', url: 'architecture-design' },
      { name: '小売', url: 'service' },
    ],
  },
]
